import { Table as Table$1 } from './components/table/Component.js';
import { Pagination } from './components/pagination/Component.js';
import { THead } from './components/thead/Component.js';
import { THeadCell } from './components/thead-cell/Component.js';
import { TSortableHeadCell } from './components/tsortable-head-cell/Component.js';
import { TBody } from './components/tbody/Component.js';
import { TCell } from './components/tcell/Component.js';
import { TRow } from './components/trow/Component.js';
import { TExpandableRow } from './components/texpandable-row/Component.js';
import 'tslib';
import 'react';
import 'classnames';
import './components/table-context/index.js';
import '../../pagination/esm';
import '../../select/esm/desktop';
import './components/pagination/select-field/index.js';
import '../../button/esm';
import './components/table/utils.js';
import './utils.js';
import './components/tsortable-head-cell/sort-icon-asc.js';
import './components/tsortable-head-cell/sort-icon-desc.js';
import './components/tsortable-head-cell/sort-icon-unset.js';

var Table = Object.assign(Table$1, {
    TBody: TBody,
    THead: THead,
    THeadCell: THeadCell,
    TSortableHeadCell: TSortableHeadCell,
    TCell: TCell,
    TRow: TRow,
    TExpandableRow: TExpandableRow,
    Pagination: Pagination,
});

export { Table };
